import { getOrganizationFirestore } from '../resources/organizationFirebase';
import { collection, deleteDoc, doc, getDocs, setDoc } from 'firebase/firestore';

export default class CategoryItemManager {
    static isLoading = false;
	static allCategories = [];


    static getAllCategories(organization){
        return new Promise((resolve, reject) => {
            this.allCategories = [];

            const firestore = getOrganizationFirestore(this.organization);
			const firestoreRef = collection(firestore, 'categories');
            getDocs(firestoreRef).then((snapshot) => {
				if (!snapshot.empty) {
					const total = snapshot.size;
					var counter = 0;
					snapshot.forEach((item) => {
						var category = item.data();
						this.allCategories.push(category)
						if (counter == total - 1) {
							this.isLoading = false
                            return resolve();
						}
						counter += 1;
					});
				} else {
					this.isLoading = false
                    return resolve();
				}
			}).catch((error) => {
					this.isLoading = false;
					return reject(error.message);
				});;
        })
    }
}